<template>
  <div class="auctions">
    <img src="../assets/logo.png" />
    <p v-if="isAuctionLive" class="days">
      Only {{ auctionTimer.days ? auctionTimer.days : 0 }} day(s) left to bid
    </p>
    <p v-else class="days">
      The auction has now finished!
    </p>
    <ul v-if="isAuctionLive" class="timer">
      <li>{{ auctionTimer.days }}<label>Days</label></li>
      <li>{{ auctionTimer.hours }}<label>Hours</label></li>
      <li>{{ auctionTimer.minutes }}<label>Mins</label></li>
      <li>{{ auctionTimer.seconds }}<label>Secs</label></li>
    </ul>
    <div class="switch">
      <router-link to="/auctions/mens">Mens</router-link>
      <router-link to="/auctions/womens">Womens</router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
import { intervalToDuration } from "date-fns";

export default {
  name: "Auctions",
  data() {
    return {
      auctionTimer: "",
      isAuctionLive: this.$store.getters.isAuctionLive,
    };
  },
  mounted() {
    setInterval(() => {
      const endDate = '2023-01-16T01:00:00.000Z';
      const now = new Date();
      const end = new Date(endDate);
      this.auctionTimer = intervalToDuration({
        start: now,
        end: end,
      });
    }, 1000);
  },
};
</script>

<style>
.auctions {
  text-align: center;
}
img {
  width: 214px;
  margin: 24px auto;
}

.switch {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.switch a {
  padding: 10px 16px;
  border: 2px solid white;
  text-decoration: none;
  color: white;
  width: 96px;
}

.switch a.router-link-active {
  background: white;
  color: #0e3f70;
}

.switch a:first-of-type {
  border-radius: 6px 0 0 6px;
  margin-right: -1px;
}
.switch a:last-of-type {
  border-radius: 0 6px 6px 0;
  margin-left: -1px;
}

.prize {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: white;
  margin-bottom: 32px;
  padding: 16px;
}

.prize dd {
  font-size: 32px;
  margin: 0;
}

.days {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 2px);
  height: 46px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  margin: 0 auto;
  margin-bottom: 32px;
  border-radius: 6px 6px 0 0;
}

.days + .timer {
  margin-top: -30px;
}

.timer {
  width: 100%;
  list-style: none;
  margin: 0 0 32px;
  padding: 0;
  display: flex;
}

.timer li {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 25%;
  height: 44px;
  color: white;
  margin: 0 1px;
  padding: 2px 0 0 0;
  background: rgba(255, 255, 255, 0.2);
}

.timer li label {
  font-size: 10px;
  margin-top: -2px;
}

.timer li:first-of-type {
  border-radius: 0 0 0 6px;
}

.timer li:last-of-type {
  border-radius: 0 0 6px 0;
}
</style>
